import { useEffect, useState } from "react";

export default function BetaFeedbackList({ api }) {
  const [orders, setOrders] = useState(null);
  useEffect(() => { api.get("/admin/starter-kit/beta").then((r) => setOrders(r.data.orders)); }, []);
  if (!orders) return <p className="text-[#6E6E6E]">Loading…</p>;
  if (!orders.length) return <p className="text-[#6E6E6E]" data-testid="sk-beta-empty">No beta kits issued yet. Use Preview &amp; Beta to send one.</p>;
  return (
    <div className="space-y-3" data-testid="sk-beta-list">
      {orders.map((o) => (
        <div key={o.id} className="border-2 border-[#D3CFC0] p-3" data-testid={`sk-beta-order-${o.id}`}>
          <div className="flex flex-wrap gap-3 items-baseline">
            <p className="font-head uppercase text-[#1E1E1E]">{o.combo.sport} {o.combo.age} · {o.combo.practice_length} min</p>
            <p className="text-xs text-[#6E6E6E]">{o.email} · {new Date(o.created_at).toLocaleString()} · email {o.email_status || "pending"} · {o.combo.players_on_court} on court · roster {o.combo.roster_size}</p>
          </div>
          {o.feedback.length === 0 ? <p className="text-xs text-[#9A9A9A] mt-1">No feedback yet.</p> : o.feedback.map((f) => (
            <div key={f.id} className="mt-2 bg-[#FBF9F5] border-l-4 border-[#DB9130] p-2 text-sm space-y-1">
              <p className="font-[IBM_Plex_Mono] text-xs">Rating {f.rating}/5 · used at practice: {f.used_at_practice === "yes" ? "yes" : "not yet"} · would pay $9: {f.would_pay}</p>
              {f.most_useful && <p><strong>Most useful:</strong> {f.most_useful}</p>}
              {f.confusing && <p><strong>Confusing:</strong> {f.confusing}</p>}
              {f.missing && <p><strong>Missing:</strong> {f.missing}</p>}
              {f.comments && <p><strong>Other:</strong> {f.comments}</p>}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
